// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group[data-v-de046d30]{margin-bottom:40px}.form-group textarea[data-v-de046d30]{resize:none;box-sizing:border-box;display:block;width:100%;padding:20px 25px;border:.5px solid rgba(0,28,45,.5);border-radius:3px;font:300 normal 14px/18px \"F37Ginger\";letter-spacing:.9px;text-transform:uppercase;height:268px}", ""]);
// Exports
module.exports = exports;
